/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_Li2Inputs */

const en_guide_json_syntax_errors_s6_li2 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for trailing commas, especially after copy-pasting from code`)
};

const ko_guide_json_syntax_errors_s6_li2 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드에서 복사-붙여넣기 후 특히 후행 쉼표를 확인하세요`)
};

const ja_guide_json_syntax_errors_s6_li2 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特にコードからのコピー＆ペースト後は、末尾のカンマを確認してください`)
};

/**
* | output |
* | --- |
* | "Check for trailing commas, especially after copy-pasting from code" |
*
* @param {Guide_Json_Syntax_Errors_S6_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_li2 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_li2(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_li2(inputs)
	return ja_guide_json_syntax_errors_s6_li2(inputs)
});